/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LadderParticipantStatus = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    BANNED: 'BANNED'
} as const;
export type LadderParticipantStatus = typeof LadderParticipantStatus[keyof typeof LadderParticipantStatus];


export function instanceOfLadderParticipantStatus(value: any): boolean {
    for (const key in LadderParticipantStatus) {
        if (Object.prototype.hasOwnProperty.call(LadderParticipantStatus, key)) {
            if (LadderParticipantStatus[key as keyof typeof LadderParticipantStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LadderParticipantStatusFromJSON(json: any): LadderParticipantStatus {
    return LadderParticipantStatusFromJSONTyped(json, false);
}

export function LadderParticipantStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderParticipantStatus {
    return json as LadderParticipantStatus;
}

export function LadderParticipantStatusToJSON(value?: LadderParticipantStatus | null): any {
    return value as any;
}

export function LadderParticipantStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LadderParticipantStatus {
    return value as LadderParticipantStatus;
}

